import React from 'react';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { ToolsDefinitionValidationError } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const FocusAreaToolsPreviewValidationErrors = ({
  validationErrors,
}: {
  validationErrors: ToolsDefinitionValidationError[];
}) => {
  const language = useLanguage();

  return (
    <div>
      {validationErrors.map((error) => {
        return (
          <S2Typography
            key={error}
            variant="body-5"
            translatedContent={language.focusAreaToolsPreviewValidationError({
              error,
            })}
          />
        );
      })}
    </div>
  );
};
